/**
 * MeetEngineerSection — Employee spotlight. v2
 * Layout: [Photo + Name + Role — left] | [Q&A list — right]
 * Q&A format: "Q: bold question" / "A: normal answer" — no accent border.
 * Canvas is always read-only. All editing in the settings panel.
 */
import React from 'react';

export function MeetEngineerSection({ section, isSelected }) {
  const data = section.data     || {};
  const st   = section.settings || {};

  const name     = data.name     || '';
  const jobTitle = data.jobTitle || '';
  const photoUrl = data.photoUrl || null;
  const qna      = data.qna      || [];

  const bg      = st.backgroundColor || '#f4efe5';
  const textCol = st.textColor        || '#000000';
  const padding = st.padding          || '28px 24px';

  const hasContent = name || photoUrl || qna.length > 0;

  return (
    <div style={{ padding, backgroundColor: bg }}>

      {/* ── Section title ─────────────────────────────────────── */}
      <div style={{ fontSize: 22, fontWeight: 700, color: textCol, marginBottom: 20, fontFamily: "'Instrument Serif', serif" }}>
        Meet the Engineer
      </div>

      {hasContent ? (
        <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start' }}>

          {/* ── Left: Photo + Name + Role ──────────────────────── */}
          <div style={{ flexShrink: 0, width: 120 }}>
            {/* Photo */}
            <div style={{
              width: 110, height: 130,
              borderRadius: 10, overflow: 'hidden',
              background: '#cfc5b5',
              marginBottom: 10,
            }}>
              {photoUrl ? (
                <img
                  src={photoUrl}
                  alt={name || 'Engineer'}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <div style={{
                  width: '100%', height: '100%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="#888">
                    <circle cx="12" cy="8" r="4" />
                    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                  </svg>
                </div>
              )}
            </div>

            {/* Name */}
            <div style={{ fontSize: 14, fontWeight: 700, color: textCol, marginBottom: 3 }}>
              {name || (isSelected ? 'Select in settings' : 'Name')}
            </div>

            {/* Role */}
            {jobTitle && (
              <div style={{ fontSize: 14, color: textCol + '99', lineHeight: 1.45 }}>
                {jobTitle}
              </div>
            )}
          </div>

          {/* ── Right: Q&A ─────────────────────────────────────── */}
          {qna.length > 0 && (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 14 }}>
              {qna.map((item) => (
                <div key={item.id}>
                  {item.question && (
                    <div style={{
                      fontSize: 14, fontWeight: 700,
                      color: textCol, marginBottom: 3,
                    }}>
                      Q: {item.question}
                    </div>
                  )}
                  {item.answer && (
                    <div style={{ fontSize: 14, color: textCol, lineHeight: 1.6 }}>
                      A: {item.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div style={{ fontSize: 14, color: textCol + '88', fontStyle: 'italic' }}>
          {isSelected
            ? 'Select an employee in the settings panel on the right'
            : 'No engineer selected yet'
          }
        </div>
      )}
    </div>
  );
}
